import { ApiLoadingStateContext } from "@/context/common/general/api-loading-context";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useContext } from "react";

type IApi = { Name: string };

/** Shared activity indicator for useApiQuery and useApiMutation, plus legacy useApi counters.
 * For a single request, prefer its own isLoading/isFetching (read) or isPending (write).
 */
function useApiLoading(apis?: IApi[], { blockingOnly = false } = {}): boolean {
  const loadingState = useContext(ApiLoadingStateContext);
  const names = apis?.map(api => api.Name);
  const matches = (meta: Record<string, unknown> | undefined) =>
    typeof meta?.apiName === "string" && !meta.disableLoader && (!names || names.includes(meta.apiName));
  const fetching = useIsFetching({
    predicate: query => matches(query.meta) && (!blockingOnly || query.state.data === undefined || query.meta?.backgroundLoader === true),
  });
  const mutating = useIsMutating({ predicate: mutation => matches(mutation.meta) });
  const legacyLoading = names ? names.some(name => (loadingState[name] ?? 0) > 0) : Object.values(loadingState).some(count => count > 0);
  return legacyLoading || fetching > 0 || mutating > 0;
}

export default useApiLoading;
